export default "__VITE_ASSET__e962a09c__"